// extracted by mini-css-extract-plugin
export default {"container":"text_container__VSWaa","inner":"text_inner__1YvjR","footer":"text_footer__138x_","content":"text_content__RgDY0"};